import { get } from 'lodash/fp'
import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'

import config from 'config'
import { reducer as rootReducer } from 'quick-quote'
import { getToggles } from 'quick-quote/feature-toggles'

/* istanbul ignore next */
let composeEnhancers = compose
if (config.ocEnvironment !== 'production' && typeof window === 'object') {
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      maxAge: 100,
      serialize: {
        replacer: (key, value) => (key === 'image' ? '' : value),
      },
      trace: true,
      traceLimit: 25,
    })
  }
}

const effectPrinter = {
  SELECT: (e) => e.selector.name,
  CALL: (e) => e.fn.name,
  PUT: (e) => e.action.type,
  FORK: (e) => `${get('args[0].type')(e) || get('args[0]')(e)} ${e.fn.name}`,
  TAKE: (e) => e.pattern,
  CANCEL: (e) => e.name,
}

const printEffect = (effect) => (type) => {
  const printer = effectPrinter[type]
  if (printer) return `${type}: ${printer(effect[type])}`
}
const logEffect = (effect) => {
  if (!effect) return
  else
    return `${Object.keys(effect)
      .filter((k) => k !== '@@redux-saga/IO')
      .map(printEffect(effect))}`
}
/* eslint-disable no-console*/
export const sagaMiddleware = createSagaMiddleware({
  sagaMonitor: {
    rootSagaStarted: (o) => console.info(`Effect Started:\tID=${o.effectId}`),
    effectTriggered: (o) => {
      if (getToggles().ENABLE_GOD_MODE && getToggles().RUNTIME_ENABLE_SAGA_MONITOR) {
        console.groupCollapsed(o.effectId, logEffect(o.effect), o)
        if (o.effect) logEffect(o.effect)
      }
    },
    effectResolved: (o) => {
      if (getToggles().ENABLE_GOD_MODE && getToggles().RUNTIME_ENABLE_SAGA_MONITOR) {
        console.info(`effectResolved: ${o.effectId}`)
        console.groupEnd(o.effectId)
      }
    },
    effectRejected: (o) => {
      if (getToggles().ENABLE_GOD_MODE && getToggles().RUNTIME_ENABLE_SAGA_MONITOR) {
        console.info(`effectRejected: ${o.effectId}`)
        console.groupEnd(o.effectId)
      }
    },
    effectCancelled: (o) => {
      if (getToggles().ENABLE_GOD_MODE && getToggles().RUNTIME_ENABLE_SAGA_MONITOR) {
        console.info(`effectCancelled: ${o.effectId}`)
        console.groupEnd(o.effectId)
      }
    },
  },
})
/* eslint-enable no-console*/
export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)))
